<template>
	<div>
<!--		<breadcrumb />-->
    <Breadtabsheader/>
		<div class="h-content">
			<div class="h-optionItem">
				<div class="h-optionItemin">
					<ul>
						<li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon1">
									<div class="h-tableCell" @click="productPage" style="cursor: pointer;">
										<p>产品画像</p>
										<!-- <span>新建计划</span> -->
									</div>
								</div>
							</a>
						</li>
						<li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon2">
									<div class="h-tableCell" @click="jingpinPage" style="cursor: pointer;">
										<p>竞品画像</p>
										<!-- <span>新建需求</span> -->
									</div>
								</div>
							</a>
						</li>
						<!-- <li>
							<a>
								<div class="h-oItemIntro h-disTable">
									<div class="h-tableCell">
										<p class="h-txtCenter">+ 增加快捷入口</p>
									</div>
								</div>
							</a>
						</li> -->
					</ul>
				</div>
			</div>
			<div class="h-row">
				<div class="h-rowIn" style="width: 61.5%;overflow:hidden">
					<div class="h-rowBox" style="height: 7.4rem;">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell" style="height:100%;display:flex;justify-content:space-between;align-items:center;">
									<h1>收入报表</h1>
									<div class="h-calendarSelect" style="margin-right: 0.2rem;">
										<div class="h-csBox">
											<el-select v-model="yearValue" placeholder="请选择" @change="getSaleRank">
												<el-option v-for="item in yearOptions" :key="item.value"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
										<span class="h-selectLine">-</span>
										<div class="h-csBox">
											<el-select v-model="monthValue" placeholder="请选择"
												@change="getSaleRank">
												<el-option v-for="item in monthOptions" :key="item.value"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
									</div>
									<div class="selecBox" v-if="selectflag">
										<div class="button" :class="{'active':indx==index}" v-for="(item,index) in buttonlist" :key="index" @click="tab(index)">{{item}}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="h-rowCon">
							<div class="blankimg" v-if="blank0" style="text-align: center;">
								<img src="../../../assets/images/mylittle.png"  style="width: 80%;">
							</div>
							<div class="agentBox" style="height: 5rem;overflow-y: auto;padding-top: 20px;" v-if="proflag">
								<div class="agent" v-for="(item,index) in productList" :key="index">
									<div class="agentTop">
										<div class="circle" :style="{'border-color':'#005cfd'}"></div>
										<div class="titles">{{item.prodName}}（{{item.regionCode2}}）</div>
									</div>
									<div class="agentBottom">
										<div class="zhaobox" :style="{'width':item.target/5+'%'}">
											<div class="zhao" :style="{'background':'#005cfd','width':item.actual/item.target*100+'%','max-width':'100%'}">
												<div class="imgs">已实现{{item.actual}}万</div>
											</div>
										</div>
										<div class="nums">{{item.target}}万</div>
									</div>
								</div>
							</div>
							<div class="agentBox" style="height: 5rem;overflow-y: auto;padding-top: 20px;" v-if="areaflag">
								<div class="agent" v-for="(item,index) in arealist" :key="index">
									<div class="agentTop">
										<div class="circle" :style="{'border-color':'#005cfd'}"></div>
										<div class="titles">{{item.regionName}}</div>
									</div>
									<div class="agentBottom">
										<div class="zhaobox" :style="{'width':item.target/20+'%'}">
											<div class="zhao" :style="{'background':'#005cfd','width':item.actual/item.target*100+'%','max-width':'100%'}">
												<div class="imgs">已实现{{item.actual}}万</div>
											</div>
										</div>
										<div class="nums">{{item.target}}万</div>
									</div>
								</div>
							</div>
							<div class="agentBox" style="padding-top: 0;" v-if="!blank0">
								<div class="lines" style="margin-top:50px;"></div>
								<div class="lineBox">
									<div class="test">销售目标</div>
									<div v-if="proflag" class="linelist" v-for="(item2,index2) in shixianlist" :key="index2">{{item2}}</div>
									<div v-if="areaflag" class="linelist" v-for="(item1,index1) in shixianlistagent" :key="index1">{{item1}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--代办-->
				<!--代办-->
				<!--代办-->
				<tasklist divheight="7.4rem" :pagesize="10"/>
				<!--代办-->
				<!--代办-->
				<!--代办-->
			</div>
			<div class="h-row">
				<div class="h-rowIn">
					<div class="h-rowBox">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell" style="display:flex;justify-content:space-between;align-items:center;height:100%;">
									<h1>产品目标</h1>
									<div class="h-calendarSelect" style="margin-left: 2rem;margin-right: 0.2rem;">
										<div class="h-csBox">
											<el-select v-model="yearValue2" placeholder="请选择" @change="getSaleRank2">
												<el-option v-for="item in yearOptions" :key="item.value"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
										<span class="h-selectLine">-</span>
										<div class="h-csBox">
											<el-select v-model="monthValue2" placeholder="请选择"
												@change="getSaleRank2">
												<el-option v-for="item in monthOptions" :key="item.value"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="h-rowCon">
							<div class="h-funnelChart">
								<div class="blankimg" v-if="blank1" style="text-align: center;">
									<img src="../../../assets/images/mylittle.png"  style="width: 50%;">
								</div>
								<div class="h-funnelChartIn" style="margin:0;width:100%;" v-if="!blank1">
									<div class="h-pieChart" id="h_line1Chart" style="width: 97%; height: 6.7rem;"></div>
								</div>
								<div class="selecBox" style="margin-left: 450px;" v-if="selectflag2">
									<div class="button" :class="{'active':paidex==index}" v-for="(item,index) in buttonlist" :key="index" @click="tab2(index)">{{item}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="h-row">
				<div class="h-rowIn">
					<div class="h-rowBox">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell">
									<h1>项目漏斗</h1>
								</div>
							</div>
						</div>
						<div class="h-rowCon">
							<div class="h-funnelChart">
								<div class="h-funnelChartIn">
									<div class="h-funnelItem">
										<span class="h-funnelTxt">
											<dictname category="xinxi_jiedian" v="R0"/>
										</span>
										<div class="h-funnelR" style="width:calc(4rem + 0*6.46rem);">
											<span>共{{total0}}条，已转化{{finish0}}条，未转化{{incomplete0}}条</span>
										</div>
										<div class="h-funnelL">
											<span class="h-funnelLTxt">转化率{{proportion0}}%</span>
											<i></i>
											<span class="h-funnelLine"></span>
										</div>
									</div>
									<div class="h-funnelItem" style="width: 80%;">
										<span class="h-funnelTxt">
											<dictname category="xinxi_jiedian" v="R1"/>
										</span>
										<div class="h-funnelR" style="width:calc(4rem + 0.1*6.46rem);">
											<span>共{{total1}}条，已转化{{finish1}}条，未转化{{incomplete1}}条</span>
										</div>
										<div class="h-funnelL">
											<span class="h-funnelLTxt">转化率{{proportion1}}%</span>
											<i></i>
											<span class="h-funnelLine"></span>
										</div>
									</div>
									<div class="h-funnelItem" style="width: 70%;">
										<span class="h-funnelTxt">
											<dictname category="xinxi_jiedian" v="R2"/>
										</span>
										<div class="h-funnelR" style="width:calc(4rem + 0.15*6.46rem);">
											<span>共{{total2}}条，已转化{{finish2}}条，未转化{{incomplete2}}条</span>
										</div>
										<div class="h-funnelL">
											<span class="h-funnelLTxt">转化率{{proportion2}}%</span>
											<i></i>
											<span class="h-funnelLine"></span>
										</div>
									</div>
									<div class="h-funnelItem" style="width: 60%;">
										<span class="h-funnelTxt">
											<dictname category="xinxi_jiedian" v="R3"/>
										</span>
										<div class="h-funnelR" style="width:calc(4rem + 0.2*6.46rem);">
											<span>共{{total3}}条，已转化{{finish3}}条，未转化{{incomplete3}}条</span>
										</div>
										<div class="h-funnelL">
											<span class="h-funnelLTxt">转化率{{proportion3}}%</span>
											<i></i>
											<span class="h-funnelLine"></span>
										</div>
									</div>
									<div class="h-funnelItem" style="width: 40%;">
										<span class="h-funnelTxt">
											<dictname category="xinxi_jiedian" v="R4"/>
										</span>
										<div class="h-funnelR" style="width:calc(4rem + 0.3*6.46rem);">
											<span>共{{total4}}条</span>
										</div>
										<div class="h-funnelL">
											<span class="h-funnelLTxt">转化率{{proportion4}}%</span>
											<i></i>
											<span class="h-funnelLine"></span>
										</div>
									</div>
									<div class="h-funnelItem" style="width: 30%;">
										<span class="h-funnelTxt">
											<dictname category="xinxi_jiedian" v="R5"/>
										</span>
										<div class="h-funnelR" style="width:calc(4rem + 0.35*6.46rem);">
											<span>共{{total5}}条</span>
										</div>
										<div class="h-funnelL">
											<span class="h-funnelLTxt">转化率{{proportion5}}%</span>
											<i></i>
											<span class="h-funnelLine"></span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
    import tasklist from '@/components/task/mytask.vue';
	import ss from "../../../api/SystemService";
	import big from 'big.js'

    export default {
        components:{
            tasklist
        },
        data() {
            return {
				selectflag:false,
				selectflag2:false,
				blank0:false,
				blank1:false,
				proflag:false,
				areaflag:false,
				total0: 0,
				total1: 0,
				total2: 0,
				total3: 0,
				total4: 0,
				total5: 0,
				finish0: 0,
				finish1: 0,
				finish2: 0,
				finish3: 0,
				incomplete0: 0,
				incomplete1: 0,
				incomplete2: 0,
				incomplete3: 0,
				proportion0: 0,
				proportion1: 0,
				proportion2: 0,
				proportion3: 0,
				proportion4: 0,
				proportion5: 0,
				yearValue:new Date().getFullYear()+"年",
				monthValue:new Date().getMonth()+1+"月",
				yearValue2:new Date().getFullYear()+"年",
				monthValue2:new Date().getMonth()+1+"月",
				indx:"",
				buttonlist:['产品','区域'],
				paiminglist:['国内','海外'],
				paidex:0,
				productList:"",
				arealist:"",
				productList2:"",
				arealist2:"",
				year:"",
				month:"",
				options: [{
				value: '选项1',
				label: '已完成'
				}, {
				value: '选项2',
				label: '未完成'
				}, {
				value: '选项3',
				label: '未开始'
				}],
				value: '',
				shixianlist:["0","100万","200万","300万","400万","500万"],
				shixianlistagent:["0","400万","800万","1200万","1600万","2000万"],
				calenderValue:new Date(),
			        yearOptions:[{
			        	value:'2017',
			        	label:'2017'
			        },{
			        	value:'2018',
			        	label:'2018'
			        },{
			        	value:'2019',
			        	label:'2019'
			        },{
			        	value:'2020',
			        	label:'2020'
			        }],
			        monthOptions:[{
			        	value:'1',
			        	label:'1月'
			        },{
			        	value:'2',
			        	label:'2月'
			        },{
			        	value:'3',
			        	label:'3月'
			        },{
			        	value:'4',
			        	label:'4月'
			        },{
			        	value:'5',
			        	label:'5月'
			        },{
			        	value:'6',
			        	label:'6月'
			        },{
			        	value:'7',
			        	label:'7月'
			        },{
			        	value:'8',
			        	label:'8月'
			        },{
			        	value:'9',
			        	label:'9月'
			        },{
			        	value:'10',
			        	label:'10月'
			        },{
			        	value:'11',
			        	label:'11月'
			        },{
			        	value:'12',
			        	label:'12月'
			        }],
					lineChart01:null,
					lineChart02:null
            }
        },
        methods: {
			getSaleRank(){
				this.getXwzMonthlySale();
			},
			getSaleRank2(){
				this.getAreaSale();
			},
			tab(index){
				this.indx = index;
				if(index == 0){
					this.proflag = true;
					this.areaflag = false;
				}else{
					this.proflag = false;
					this.areaflag = true;
				}
			},
			productPage(){
				this.$router.push({path:"/chanp/productManage"});
			},
			jingpinPage(){
				this.$router.push({path:"/jingpin/detailall"});
			},
			tab2(index){
				this.paidex = index;
				var areaData = [];
				var target = [];
				var actual = [];
				if(index==0){
					for(var i=0;i<this.productList2.length;i++){
						var cl = this.productList2[i];
						if(cl.regionCode2=="GUO_NEI"){
							cl.regionCode2 = "国内";
						}else if(cl.regionCode2=="HAI_WAI"){
							cl.regionCode2 = "海外";
						}
						areaData.push(cl.prodName+'（'+cl.regionCode2+'）');
						target.push(cl.target);
						actual.push(cl.actual);
					}
				}else if(index==1){
					for(var i=0;i<this.arealist2.length;i++){
						var cl = this.arealist2[i];
						if(cl.regionCode2=="GUO_NEI"){
							cl.regionCode2 = "国内";
						}else if(cl.regionCode2=="HAI_WAI"){
							cl.regionCode2 = "海外";
						}
						areaData.push(cl.regionName);
						target.push(cl.target);
						actual.push(cl.actual);
					}
				}
				let lineChart = this.$echarts.init(document.getElementById('h_line1Chart'));
				lineChart.setOption({
					xAxis:{
						data:areaData
					},
					series:[{
						name:"目标",
						data:target
					},
					{
						name:"已达成",
						data:actual
					}]
				})
			},
			handleYearClick(){
				this.calenderValue = (this.yearValue+"-"+this.monthValue).split("月")[0]
			},
			handleMonthClick(){
				this.calenderValue = this.yearValue.split("年")[0]+"-"+this.monthValue
			},
			handleDateClick(a){
				this.yearValue = a.getFullYear()+"年";
				this.monthValue = a.getMonth()+1+"月"
			},
			lineChart1(){
				this.lineChart01 = this.$echarts.init(document.getElementById('h_line1Chart'));
				let option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {
						data: ['已达成', '目标'],
						x:"right",
						y:"top"
					},
					grid: {
						left: 50,
						right: 50,
						bottom: 50,
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: [],
						boundaryGap: [0, 0.01],
						show : true,
						axisLabel: {  
						   interval:0,  
						   // rotate:40  
						}  
					},
					yAxis: {
						type: 'value',
						show : true,
						name: '单位：元'
					},
					series: [
						{
							name: '已达成',
							type: 'bar',
							barGap:'0',
							barWidth: '25%',
							data: [],
							itemStyle:{
								normal:{
									color:"#4f8bfe"
								}
							}
						},
						{
							name: '目标',
							type: 'bar',
							barGap:'0',
							barWidth: '25%',
							data: [],
							itemStyle:{
								normal:{
									color:"#fec02a"
								}
							}
						}
					]

				}
				this.lineChart01.setOption(option);
				
			},
			getAreaSale(){
				ss.firstPageService.getXwzMonthlySale({month:this.getMonthStr(this.yearValue2,this.monthValue2,'')}).then(rd=>{
					this.productList2 = rd.prolist;
					this.arealist2 = rd.arealist;
					var areaData = [];
					var target = [];
					var actual = [];
					if(this.productList2.length > 0){
						this.blank1=false;
						for(var i=0;i<this.productList2.length;i++){
							var cl = this.productList2[i];
							if(cl.regionCode2=="GUO_NEI"){
								cl.regionCode2 = "国内";
							}else if(cl.regionCode2=="HAI_WAI"){
								cl.regionCode2 = "海外";
							}
							areaData.push(cl.prodName+'（'+cl.regionCode2+'）');
							target.push(cl.target);
							actual.push(cl.actual);
						}
						if(this.arealist2.length > 0){
							this.selectflag2=true;
							this.paidex=0;
						}
					}else if(this.arealist2.length > 0){
						this.blank1=false;
						for(var i=0;i<this.arealist2.length;i++){
							var cl = this.arealist2[i];
							if(cl.regionCode2=="GUO_NEI"){
								cl.regionCode2 = "国内";
							}else if(cl.regionCode2=="HAI_WAI"){
								cl.regionCode2 = "海外";
							}
							areaData.push(cl.regionName);
							target.push(cl.target);
							actual.push(cl.actual);
						}
					}else{
						this.blank1 = true;
					}
					let lineChart = this.$echarts.init(document.getElementById('h_line1Chart'));
					lineChart.setOption({
						xAxis:{
							data:areaData
						},
						series:[{
							name:"目标",
							data:target
						},
						{
							name:"已达成",
							data:actual
						}]
					})
				})
			},
			showLoud(){
				ss.firstPageService.showLoud().then(rd=>{
					this.total0 = parseInt(rd.R0?rd.R0:0) + parseInt(rd.R1?rd.R1:0) + parseInt(rd.R2?rd.R2:0) + parseInt(rd.R3?rd.R3:0) + parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.total1 = parseInt(rd.R1?rd.R1:0) + parseInt(rd.R2?rd.R2:0) + parseInt(rd.R3?rd.R3:0) + parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.total2 = parseInt(rd.R2?rd.R2:0) + parseInt(rd.R3?rd.R3:0) + parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.total3 = parseInt(rd.R3?rd.R3:0) + parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.total4 = parseInt(rd.R4?rd.R4:0);
					this.total5 = parseInt(rd.R5?rd.R5:0);
					this.finish0 = parseInt(rd.R1?rd.R1:0) + parseInt(rd.R2?rd.R2:0) + parseInt(rd.R3?rd.R3:0) + parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.finish1 = parseInt(rd.R2?rd.R2:0) + parseInt(rd.R3?rd.R3:0) + parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.finish2 = parseInt(rd.R3?rd.R3:0) + parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.finish3 = parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.incomplete0 = this.total0 - this.finish0;
					this.incomplete1 = this.total1 - this.finish1;
					this.incomplete2 = this.total2 - this.finish2;
					this.incomplete3 = this.total3 - this.finish3;
					this.proportion0 = (new big(this.finish0).div(this.total0)).times(100);
					this.proportion1 = (new big(this.finish1).div(this.total1)).times(100);
					this.proportion2 = (new big(this.finish2).div(this.total2)).times(100);
					this.proportion3 = (new big(this.finish3).div(this.total3)).times(100);
					this.proportion4 = (new big(this.total4).div(this.total2)).times(100);
					this.proportion5 = (new big(this.total5).div(this.total3)).times(100);
				})
			},
			getXwzMonthlySale(){
				ss.firstPageService.getXwzMonthlySale({month:this.getMonthStr(this.yearValue,this.monthValue,'')}).then(rd=>{
					this.productList = rd.prolist;
					this.arealist = rd.arealist;
					if(this.productList.length > 0){
						this.blank0 = false;
						this.proflag = true;
						_.forEach(this.productList,(value)=>{
							if(value.regionCode2=="GUO_NEI"){
								value.regionCode2 = "国内";
							}else if(value.regionCode2=="HAI_WAI"){
								value.regionCode2 = "海外";
							}
						})
						if(this.arealist.length > 0){
							this.selectflag = true;
							this.areaflag = false;
							this.indx = 0;
						}
					}else if(this.arealist.length > 0){
						this.blank0 = false;
						this.areaflag = true;
					}else{
						this.blank0 = true;
					}
				})
			},
			getMonthStr(yearValue, monthValue, separator){
				var year = yearValue.split('年')[0];
				var month = monthValue.split('月')[0];
				month = month.length==1?'0'+month:month;
				return year + separator + month;
			},
        },
		mounted(){
			this.lineChart1();
			//产品收入
			this.getXwzMonthlySale();
			this.year = new Date().getFullYear();
			this.month = new Date().getMonth()+1;
			//产品目标
			this.getAreaSale();
			//项目漏斗
			this.showLoud();
			// let that = this;
			// window.addEventListener('resize',function () {
			//    that.lineChart01.resize();
			//    that.lineChart02.resize();
			//    
			// })
		},
    }
</script>

<style scoped>
.h-funnelChart .h-funnelItem .h-funnelR {
	height: 0.64rem;
	line-height: 0.62rem;
	position: absolute;
	left: calc(100% + 0.6rem);
	top: -0.64rem;
	width: 5rem;
	color: #3b77fd;
	font-size: 0.18rem;
	text-align: left;
	padding-left: 0.56rem;
	background-image: url(../../../assets/images/trapezoid1.png);
	background-repeat: no-repeat;
	background-size: 100% 100%;
}
.selecBox{
	display: flex;
}
.selecBox .button{
	width: 85px;
	height: 32px;
	color: #767676;
	text-align: center;
	line-height: 28px;
	border:1px solid #dddfe4;
	background: #fff;
	cursor: pointer;
	font-size: 0.16rem;
}
.selecBox .button.active{
	background: #2686e7;
	color: #fff;
	border-color: #2686e7;
}
.mubiaoBox{
	display: flex;
	justify-content: center;
}
.mubiaoBox .mubiao{
	display: flex;
	justify-content: center;
	align-items: center;
}
.mubiaoBox .mubiao .mubiaobutton{
	width: 30px;
	height: 18px;
	background: #4f8bfe;
}
.mubiaoBox .mubiao .mubiaotext{
	margin-left: 20px;
	color: #595959;
	font-size: 0.16rem;
}
.agentBox{
	width: 100%;
	padding: 0 0.2rem;
}
.agentBox .agent{
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-top: 0.18rem;
}
.agentBox .agent:first-child{
	margin-top:0
}
.agentBox .agent .agentTop{
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.agentBox .agent .agentTop .circle{
	width: 12px;
	height: 12px;
	border: 3px solid #64a5f8;
	margin-right: 10px;
	border-radius: 50%;
}
.agentBox .agent .agentTop .titles{
	font-size: 16px;
	color: #a9a9a9;
}
.agentBox .agent .agentBottom{
	margin-top: 0.15rem;
	display: flex;
}
.agentBox .agent .agentBottom .zhaobox{
	width: 90%;
	height: 0.16rem;
	background: #e2f1ff;
	border-radius: 8px;
	position: relative;
}
.agentBox .agent .agentBottom .nums{
	width: 10%;
	font-size: 16px;
	color: #a9a9a9;
	text-align: right;
}
.agentBox .agent .agentBottom .zhaobox .zhao{
	position: absolute;
	top: 0;
	left:0;
	width: 16.5%;
	height: 0.16rem;
	border-radius: 8px;
	background: #005cfd;
	transition: all 0.3s;
}
.agentBox .agent .agentBottom .zhaobox:hover .zhao .imgs{
	display: block;
}
.agentBox .agent .agentBottom .zhaobox .zhao .imgs{
	width: 126px;
	height: 57px;
	background: url(../../../assets/images/titp.png);
	position: absolute;
	top: -60px;
	right: -90px;
	color: #949b9e;
	font-size: 16px;
	text-align: center;
	line-height: 40px;
	display: none;
}
.agentBox .lines{
	width: 100%;
	height: 1px;
	background: #f6f6f6;
	margin-top: 40px;
}
.agentBox .lineBox{
	position: relative;
	width: 100%;
	display: flex;
}
.agentBox .lineBox .linelist{
	width: 16.5%;
	margin-top: 10px;
	text-align: center;
	font-size: 14px;
	color:#4d4d4d;
}
.agentBox .lineBox .test{
	position: absolute;
	top: -25px;
	left: 0;
	font-size: 14px;
	color:#4d4d4d;
}
</style>
<style>
.h-tableCell .el-input__inner {
	width: 1.3rem;
    color: #DCDFE6;
    border-radius: 0;
    height: 0.32rem;
    line-height: 0.28rem;
    border: 1px solid #DCDFE6;
    font-size: 0.16rem;
    padding-right: 0.3rem;
    padding-left: 0.15rem;
}
.h-tableCell .el-input__icon{
	line-height: 0;
}
.fenyes .h-pagiLabel{
	display: none;
}
.fenyes .el-pagination .el-pagination__sizes{
	display: none;
}
</style>
